import { Text, View, StyleSheet } from '@react-pdf/renderer';

interface TableRow {
  code: string;
  title: string;
  result: string;
  id: string;
}

const styles = StyleSheet.create({
  table: {
    width: '100%',
    marginBottom: 0,
    fontSize: 10,
  },
  row: { flexDirection: 'row', flexWrap: 'nowrap', marginTop: '2px' },
  cell: {
    padding: 2,
    flex: 1,
    textAlign: 'left',
    flexShrink: 1,
    flexGrow: 0,
    whiteSpace: 'nowrap',
    minWidth: '80px',
  },
  resultCell: {
    minWidth: '80px',
  },
  titleCell: { padding: 2, flex: 1, textAlign: 'left', flexGrow: 1, flexBasis: 0 },
  header: { borderBottomWidth: 2, borderBottomColor: '#cfced0' },
});

function Table({ data }: { data?: TableRow[] }): React.ReactElement {
  return (
    <View style={styles.table}>
      <View style={[styles.row, styles.header]}>
        <Text style={styles.cell}>Unit code</Text>
        <Text style={styles.titleCell}>Unit title</Text>
        <Text style={styles.cell}>Result</Text>
      </View>
      {data?.map((row) => (
        <View style={styles.row} key={row.id}>
          <Text style={styles.cell}>{row.code}</Text>
          <Text style={styles.titleCell}>{row.title}</Text>
          <Text style={styles.cell}>{row.result}</Text>
        </View>
      ))}
    </View>
  );
}

export default Table;
